import { Form, Mentions, Select } from 'antd'
import { useCallback, useMemo, useState } from 'react'

export default function AddCart({ fieldName, parameters }) {
  const available = useMemo(() => {
    const props = parameters?.properties
    if (!props) return []
    const arr = Array.isArray(props)
      ? props
      : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
    return arr.map(({ name }) => ({ label: name, value: name }))
  }, [parameters])

  return (
    <>
      <Form.Item
        label={'Variável com ID do produto'}
        rules={[
          {
            required: true,
            message: 'É preciso escolher um parametro do gatilho',
          },
        ]}
        name={[fieldName, 'action', 'data', 'item_id']}
      >
        <Select
          placeholder={'Variável que representa o id do produto'}
          options={available}
        />
      </Form.Item>
      <Form.Item
        label={'Variável que representa a quantidade'}
        rules={[
          {
            required: true,
            message: 'É preciso escolher um parametro do gatilho',
          },
        ]}
        name={[fieldName, 'action', 'data', 'quantity']}
      >
        <Select
          placeholder={'Variável que representa a quantidade de produto'}
          options={available}
        />
      </Form.Item>
    </>
  )
}
